import React, { useMemo, useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import ReactPlaceholder from 'react-placeholder/lib'
import { useParams } from 'react-router-dom'
import Controllers from '../../Api/Controllers'
import parse from 'html-react-parser'
import Helpers from '../../Components/Helpers/Helpers'
import { SurfaceCard } from '../../Components/Ui'
import { FormCustom, TextArea } from '../../Components/Form/Form'
import { toast } from 'react-toastify'
import { useSelector } from 'react-redux'
import CommentEvent from './CommentEvent'

const avatarFallback = (e) => {
    e.currentTarget.style.display = 'none'
    if (e.currentTarget.nextSibling) e.currentTarget.nextSibling.style.display = 'inline-flex'
}

const btnPrimary = {
    borderRadius: 12,
    fontWeight: 700,
    minHeight: 42,
    padding: '0 18px',
    background: '#201030',
    color: '#fff',
    border: 'none',
    cursor: 'pointer',
    display: 'inline-flex',
    alignItems: 'center',
    gap: 8
}

const EventBlog = () => {
    const [event, setEvent] = useState({})
    const [ready, setReady] = useState(false)
    const [readyComments, setReadyComments] = useState(false)
    const [reloadComments, setReloadComments] = useState(true)
    const [loadSubmit, setLoadSubmit] = useState(false)
    const [row, setRow] = useState({
        p_id_event: '',
        p_description_comment: ''
    })

    const store = useSelector(res => res)
    const [comments, setComments] = useState([])

    const { tokenEvent } = useParams()

    useEffect(() => {
        setReady(false)
        Controllers.event.get_event_token({
            p_token_event: tokenEvent
        }).then(res => {
            setRow({ ...row, p_id_event: res.data?.id_event })
            setEvent(res.data)
            setReady(true)
        })
    }, [tokenEvent])

    useEffect(() => {
        setReadyComments(true)
        Controllers.comment.get_comment_event({
            p_id_event: tokenEvent
        }).then(res => {
            setComments(res.data)
            setReloadComments(false)
            setReadyComments(true)
        })
    }, [tokenEvent, reloadComments])

    const handleSubmitComment = ({ data }) => {
        setLoadSubmit(true)
        Controllers.comment.comment_event_insert_update(data).then(res => {
            Helpers.toast.construct({ ...res, toast })
            setRow({ ...row, p_description_comment: '' })
            setReloadComments(true)
            setLoadSubmit(false)
        })
    }

    const qtyComments = useMemo(() => {
        let qty = comments.length

        comments.forEach(c => {
            qty += parseInt(c.comments_child.length)
        })
        return qty
    }, [comments])

    return (
        <ReactPlaceholder ready={ready} showLoadingAnimation rows={15}>
            {event?.name_event ? <>
                <div style={{ padding: '8px 4px 16px' }}>
                    <h2 style={{ margin: '0 0 12px', fontSize: '1.35rem', fontWeight: 800, color: '#201030' }}>
                        {event.name_event}
                    </h2>
                    {event.file_images ? (
                        <img
                            src={Helpers.config.resourcesUrl({ url: event.file_images })}
                            alt=""
                            style={{ width: '100%', maxHeight: 360, objectFit: 'cover', borderRadius: 16, marginBottom: 16 }}
                        />
                    ) : null}
                    <div className="content_article_preview" style={{ color: '#374151', fontSize: '0.95rem', lineHeight: 1.6 }}>
                        {parse(`${event.content_event}`)}
                    </div>
                </div>

                <ReactPlaceholder className="mb-2" ready={readyComments} showLoadingAnimation rows={1}>
                    <h3 style={{ margin: '8px 4px 16px', fontSize: '1.05rem', fontWeight: 800, color: '#201030' }}>
                        {qtyComments} Comentarios
                    </h3>
                </ReactPlaceholder>

                <div className="form-row">
                    <div className="col-12 col-lg-4 mb-3">
                        <SurfaceCard title="Tu comentario">
                            <div className="d-flex align-items-center mb-3" style={{ gap: 10 }}>
                                <img
                                    src={store.session.file_photo_user}
                                    alt=""
                                    width="36"
                                    height="36"
                                    style={{ borderRadius: 999, objectFit: 'cover' }}
                                    onError={avatarFallback}
                                />
                                <span style={{ fontWeight: 600, color: '#201030', fontSize: '0.88rem' }}>
                                    {store.session.full_name || 'Tú'}
                                </span>
                            </div>
                            <FormCustom viewSubmit={false} dataSubmit={row} onSubmit={handleSubmitComment}>
                                <TextArea
                                    text="Escribe tu comentario"
                                    classNameParent="col-12"
                                    rows="5"
                                    required
                                    value={row.p_description_comment}
                                    onChange={e => setRow({ ...row, p_description_comment: e.currentTarget.value })}
                                />
                                <div className="col-12 mt-3">
                                    <button type="submit" style={btnPrimary}>
                                        {loadSubmit
                                            ? <i className="fa fa-circle-notch fa-spin" />
                                            : <><i className="fa fa-paper-plane" />Enviar</>}
                                    </button>
                                </div>
                            </FormCustom>
                        </SurfaceCard>
                    </div>
                    <div className="col-12 col-lg-8">
                        <ReactPlaceholder className="mb-2" ready={readyComments} showLoadingAnimation rows={15}>
                            {comments.length === 0 ? (
                                <div className="alert alert-warning mb-0" style={{ borderRadius: 14 }}>
                                    <strong>¡Sé el primero!</strong> Deja tu comentario.
                                </div>
                            ) : (
                                React.Children.toArray(comments.map(c => (
                                    <CommentEvent comment={c} onSuccess={() => setReloadComments(true)} />
                                )))
                            )}
                        </ReactPlaceholder>
                    </div>
                </div>
            </> : <>
                <div className="alert alert-warning" style={{ borderRadius: 14 }}>
                    <strong>¡Lo sentimos!</strong> No se ha encontrado información.
                </div>
                <Link to={Helpers.config.convertUrl({ url: '/evento-historico' })}>
                    <button type="button" style={btnPrimary}>
                        <i className="fa fa-arrow-left" />Regresar
                    </button>
                </Link>
            </>}
        </ReactPlaceholder>
    )
}

export default EventBlog
